import React from 'react';
import { TypedAplication } from '../../@types';
import PendingAproveItem from './PendingAproveItem';

interface PendingAproveListProps {
  itens: TypedAplication[];
  isLoading: boolean;
}

const PendingAproveList: React.FC<PendingAproveListProps> = ({
  itens,
  isLoading,
}) => (
  <div className="integration-errors-list-wrapper">
    {isLoading && (
      <div className="empty-state">
        <i className="pi pi-spin pi-spinner" />
        <p>Carregando registros</p>
      </div>
    )}
    {!isLoading && itens.length === 0 && (
      <div className="empty-state">
        <i className="pi pi-search" />
        <p>Nenhum registro encontrado</p>
      </div>
    )}
    {!isLoading && itens.length > 0 && (
      <div className="integration-errors-list">
        {itens.map((item) => (
          <PendingAproveItem key={item.id} item={item} />
        ))}
      </div>
    )}
  </div>
);

export default React.memo(PendingAproveList);
